import React from "react";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "react-i18next";
import { BUS_QR_LINKS } from "../config/busQrLinks";

function TikTokIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
    </SvgIcon>
  );
}

const BUTTONS = [
  {
    key: "instagram",
    href: BUS_QR_LINKS.instagram,
    Icon: InstagramIcon,
    sx: {
      background: "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
      color: "#fff",
      "&:hover": {
        background: "linear-gradient(45deg, #d8852e 0%, #cc5e36 25%, #c4233c 50%, #b01f5b 75%, #a31579 100%)",
      },
    },
  },
  {
    key: "tiktok",
    href: BUS_QR_LINKS.tiktok,
    Icon: TikTokIcon,
    sx: {
      backgroundColor: "#000",
      color: "#fff",
      "&:hover": { backgroundColor: "#1a1a1a" },
    },
  },
  {
    key: "whatsapp",
    href: BUS_QR_LINKS.whatsappGroup,
    Icon: WhatsAppIcon,
    sx: {
      backgroundColor: "#25D366",
      color: "#fff",
      "&:hover": { backgroundColor: "#1ebe57" },
    },
  },
];

const BusQrPage = () => {
  const { t } = useTranslation("common");
  const visible = BUTTONS.filter((b) => b.href);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        py: { xs: 4, sm: 6 },
        px: { xs: 2, sm: 4 },
        minHeight: "50vh",
      }}
    >
      <Container maxWidth="sm">
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 700, mb: 1, color: "#1F2937", textAlign: "center" }}
        >
          {t("busQr.title")}
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 4, color: "#6B7280", textAlign: "center" }}
        >
          {t("busQr.subtitle")}
        </Typography>

        <Stack spacing={2}>
          {visible.map(({ key, href, Icon, sx }) => (
            <Button
              key={key}
              component="a"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              fullWidth
              size="large"
              variant="contained"
              disableElevation
              startIcon={<Icon />}
              aria-label={t(`busQr.${key}`)}
              sx={{
                py: 1.5,
                textTransform: "none",
                fontWeight: 600,
                fontSize: "1rem",
                borderRadius: 2,
                ...sx,
              }}
            >
              {t(`busQr.${key}`)}
            </Button>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

export default BusQrPage;
